import { render, staticRenderFns } from "./ManageWarrants3Reminders.vue?vue&type=template&id=57a01cc6&scoped=true"
import script from "./ManageWarrants3Reminders.vue?vue&type=script&lang=js"
export * from "./ManageWarrants3Reminders.vue?vue&type=script&lang=js"
import style0 from "./ManageWarrants3Reminders.vue?vue&type=style&index=0&id=57a01cc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a01cc6",
  null
  
)

export default component.exports